<mat-card class="keyword-list-container">
  <mat-card-header>
    <mat-card-title>Your keywords</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div cdkDropList
         id="keyword-source-list"
         [cdkDropListData]="keywordItems"
         class="keywords-wrapper"
         [cdkDropListConnectedTo]="allDropListsIds()">
      @for (queryItem of keywordItems(); track queryItem.uId) {
        @if (queryItem.keyword) {
          <app-search-query-keyword [keyword]="queryItem.keyword"
                                    cdkDrag
                                    (cdkDragStarted)="setDragStarted(true) "
                                    (cdkDragEnded)="setDragStarted(false) "
                                    [showDelete]="false"
                                    [cdkDragData]="queryItem"
                                    [transparent]="false"
          ></app-search-query-keyword>
        }
        <div *cdkDragPreview class="keyword-preview">{{ queryItem.keyword!.keyword }}</div>
      }
    </div>
  </mat-card-content>
</mat-card>
